import React from "react";
import { connect } from "react-redux";
import { Map } from "immutable";
import {
    Progress,
    Button,
    ButtonActionGroup,
    Confirm,
    BTN_SMALL,
    TYPE_SECONDARY,
    TYPE_FAILURE,
} from "../../lib";
import { navigate } from "../../services";

import { setDocLastOpened } from "../../reducers/settings/actions";
import { removePageAutoComplete } from "../../reducers/autocomplete/actions";
import { destroyPage, fetchPages } from "../../reducers/pages/actions";
import { AppState } from "../../store";

const mapPropsToState = (
    { settings, pages }: AppState,
    { doc_id }: OwnProps
) => ({
    // @ts-ignore
    docLastOpened: settings.get("docLastOpened") as Map<number, number>,
    pages: Map<string, any>(
        // @ts-ignore
        pages.filter((p: any) => p.get("doc_id") === doc_id)
    ),
});
const mapDispatch = {
    destroyPage,
    fetchPages,
    setDocLastOpened,
    removePageAutoComplete,
};

type StateProps = ReturnType<typeof mapPropsToState>;
type DispatchProps = typeof mapDispatch;

type OwnProps = {
    doc_id: number;
    page_id: number;
    size: number;
    selected: number[];

    clearSelected: () => void;
};
type Props = StateProps & DispatchProps & OwnProps;
type State = {
    processing: boolean;
    confirmDelete: boolean;
};

class Actions extends React.Component<Props, State> {
    state = {
        processing: false,
        confirmDelete: false,
    };

    getParams = () => ({
        doc_id: this.props.doc_id,
        page_id: this.props.selected[0],
    });

    onEditClick = () => {
        const { doc_id, page_id } = this.getParams();
        navigate.to(`/app/page/edit/${doc_id}/${page_id}`);
    };

    onEditDocClick = () => {
        const { doc_id, page_id } = this.getParams();
        navigate.to(`/app/e/${doc_id}/${page_id}`);
    };

    onDeleteClick = () => this.setState({ confirmDelete: true });

    onConfirmDelete = () => {
        const { doc_id, selected, pages, docLastOpened } = this.props;

        try {
            selected.forEach((page_id) => {
                this.props.destroyPage({ page_id, doc_id });
                this.props.removePageAutoComplete({ page_id, doc_id });
            });

            if (
                docLastOpened.has(doc_id) &&
                selected.includes(docLastOpened.get(doc_id)!)
            ) {
                const firstPageId = pages
                    .min((p: any) => p.position)!
                    .get("id");
                this.props.setDocLastOpened({ doc_id, page_id: firstPageId });
            }
        } catch (e) {
            console.warn(e);
        }

        this.setState({ confirmDelete: false });
        this.props.clearSelected();
    };

    onCancelDelete = () => {
        this.setState({ confirmDelete: false });
        this.props.clearSelected();
    };

    onReturnClick = () => {
        const { doc_id, page_id, docLastOpened } = this.props;

        if (docLastOpened.has(doc_id)) {
            const lastOpened = docLastOpened.get(doc_id);
            navigate.to(`/app/e/${doc_id}/${lastOpened}`);
        } else {
            navigate.to(`/app/e/${doc_id}/${page_id}`);
        }
    };

    render() {
        if (this.state.processing) {
            return <Progress margin="50px 0" />;
        }

        const { size, selected } = this.props;
        const selectedOne = selected.length === 1;

        if (this.state.confirmDelete) {
            return (
                <Confirm
                    type={TYPE_FAILURE}
                    onConfirm={this.onConfirmDelete}
                    onCancel={this.onCancelDelete}
                    messageId={
                        selectedOne
                            ? "pageForm.confirmRemove"
                            : "pageForm.confirmRemoveAll"
                    }
                />
            );
        }

        return (
            <ButtonActionGroup>
                {selectedOne && (
                    <Button
                        size={BTN_SMALL}
                        type={TYPE_SECONDARY}
                        messageId="pageForm.edit"
                        onClick={this.onEditClick}
                    />
                )}

                {selectedOne && (
                    <Button
                        size={BTN_SMALL}
                        messageId="doc.editDoc"
                        onClick={this.onEditDocClick}
                    />
                )}

                {size > 1 && selected.length > 0 && (
                    <Button
                        size={BTN_SMALL}
                        type={TYPE_FAILURE}
                        messageId="pageForm.remove"
                        onClick={this.onDeleteClick}
                    />
                )}

                <Button
                    size={BTN_SMALL}
                    type={TYPE_SECONDARY}
                    messageId="form.return"
                    onClick={this.onReturnClick}
                />
            </ButtonActionGroup>
        );
    }
}

export default connect(mapPropsToState, mapDispatch)(Actions);
